import { Rings } from "react-loader-spinner";
import { useLoader } from '../../../hooks/useLoader';

export function Loader(){
    const { loader } = useLoader()
    const primaryColor = process.env.REACT_APP_COR_TEMA || '#007BFF' //Cor primaria AdminLTE

    return (
        <>
            {((loader !== "") ?
                <div className={`overlay${(loader !== "loaderLogin" ? ' overlay-custom' : '')}`}>
                    <Rings
                        type="Puff"
                        // eslint-disable-next-line no-undef
                        color={primaryColor}
                        // color="#1C4F25"
                        // color="#3c8dbc"
                        height={100}
                        width={100}
                        visible={true} 
                    />
                </div>
            : null)}
        </>
    )
}